













import { Component, Vue } from 'vue-property-decorator';
import Forms from '@/components/Forms.vue';
import get from 'lodash/get';
import NotificationModel from '../models/Notification';
import {
    getNotification,
    postNotification,
    patchNotification,
} from '../api/api';
import { Route } from 'vue-router';

let notification: NotificationModel | null = null;

async function computeBreadcrumb(to: Route, from: Route, next: Function) {
    try {
        if (to.params.id) {
            const { data: notificationObj } = await getNotification(
                +to.params.id
            );
            notification = notificationObj;

            to.meta.breadcrumb[2].title = notification.name;
        }
    } catch (error) {
        if (error.response.status == 404) {
            Vue.prototype.$vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: `Notification introuvable.`,
            });

            next({
                name: 'notifications',
            });
            return;
        }
    }

    next();
}

@Component({
    beforeRouteEnter: computeBreadcrumb,
    beforeRouteUpdate: computeBreadcrumb,
    components: {
        Forms,
    },
})
export default class NotificationForm extends Vue {
    errors: any = {};
    notification: NotificationModel | null = notification;
    loading: boolean = false;
    get type(): 'edit' | 'add' {
        return this.$route.name === 'addNotification' ? 'add' : 'edit';
    }
    get items() {
        return [
            {
                name: 'name',
                label: 'Nom *',
                type: 'text',
                errorMessage: 'Le nom est requis',
                required: true,
            },
            {
                name: 'description',
                label: 'Description',
                type: 'textarea',
            },
            // {
            //     name: 'type',
            //     label: 'Type *',
            //     type: 'text',
            //     errorMessage: 'Le type est requis',
            //     required: true,
            // },
            {
                name: 'enabled',
                label: 'Activé',
                type: 'switch',
            },
            {
                name: 'title',
                label: 'Titre de la notification *',
                type: 'text',
                errorMessage: 'Le titre est requis',
                required: true,
            },
            {
                name: 'content',
                label: 'Contenu de la notification *',
                type: 'texteditor',
                errorMessage: 'Le contenu est requis',
                required: true,
            },
        ];
    }
    defaultValue: any | null = {
        name: null,
        description: null,
        title: null,
        content: null,
        enabled: null,
    };

    async created(): Promise<void> {
        this.loading = true;
        if (this.type === 'edit' && this.notification) {
            this.defaultValue.name = this.notification.name || null;
            this.defaultValue.description =
                this.notification.description || null;
            this.defaultValue.title = this.notification.title || null;
            this.defaultValue.content = this.notification.content || null;
            this.defaultValue.type = this.notification.type || null;
            this.defaultValue.enabled = this.notification.enabled || null;
        }
        this.loading = false;
    }

    async submit(form: any) {
        this.loading = true;
        const newNotification: NotificationModel = {
            name: form.name,
            description: form.description,
            title: form.title,
            content: form.content,
            type: form.type,
            enabled: form.enabled,
        };

        const $vs = (this as any).$vs;
        try {
            if (this.type === 'add') {
                await postNotification(newNotification);
                $vs.notify({
                    color: 'success',
                    position: 'top-right',
                    title: 'Création',
                    text: `Création de la notification réussie`,
                });
            } else {
                await patchNotification(
                    +this.$route.params.id,
                    newNotification
                );
                $vs.notify({
                    color: 'success',
                    position: 'top-right',
                    title: 'Modification',
                    text: `Modification de la notification réussie`,
                });
            }
            this.$router.push({ name: 'notifications' });
        } catch (error) {
            this.errors = error.response.data.errors.children;
            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: 'Erreur lors de la soumission du formulaire',
            });
        } finally {
            this.loading = false;
        }
    }
}
